import { extractIDs } from "helpers/extractIDs";
import { validateObject } from "helpers/validateObject";
import { createSelector } from "reselect";

export const handleFilterStations = (selected, data, stations={}) => {
  const ids = extractIDs(selected)
 return data.filter(tax => {
    const tempIDs = extractIDs(tax.stations, 'idStation')
    return ids.some(id => tempIDs.includes(id))
  }).map(taxi => {
    const labels = taxi.stations.map(sta => stations[sta.idStation].name)
    const newSet = [...new Set(labels)].flat().join(", ")
    return {
      ...taxi,
      stationLabel: newSet
    }
  })
}


export const taxiSelector = createSelector((state) => {
  const {taxis, stationsSelected} = state.taxis;
  const stations = state.companies.stations
  let taxisWithStations = []
  if(validateObject(stations)) {
    taxisWithStations = handleFilterStations(stationsSelected, taxis, stations)
  }
  return taxisWithStations
},
  (taxis) => taxis
)


export const customersOptSelector = createSelector((state) => {
  const stations = state.companies.stations
  const opts = state.taxis.customersOpt
  const nOpts = opts.map(opt => {
    return {
      ...opt,
      label: `${opt.name} - ${stations[opt?.idStation]?.label}`
    }
  })
  return nOpts
},
  (customersOpt) => customersOpt
)
